import React, { useMemo } from 'react';
import AccountSelector from 'components/AccountSelector';
import AccountContext, { AccountContextInterface } from 'storage/AccountContext';
import ProfileInfoContext from 'storage/ProfileInfoContext';

import './accountSelectorForm.scss';

const AccountSelectorForm: React.VFC = () => {
  const { accountsList, selectedAccount, setSelectedAccountById } = AccountContext.useContext();
  const { profileInfo } = ProfileInfoContext.useContext();

  const [selected, setSelected] = React.useState<AccountContextInterface['accountsList'][0]>(selectedAccount);

  const isAdmin = profileInfo?.admin || false;

  // Account status enum (same mapping used in AccountSelector)
  const ACCOUNT_STATUS = {
    ACTIVE: 0,
    ON_HOLD: 1,
    INACTIVE: 2,
  };

  const { activeAccounts, inactiveAccounts, onHoldAccounts } = useMemo(() => {
    const activeAccounts: typeof accountsList = [];
    const onHoldAccounts: typeof accountsList = [];
    const inactiveAccounts: typeof accountsList = [];

    for (const acc of accountsList) {
      switch (acc.status) {
        case ACCOUNT_STATUS.ACTIVE:
          activeAccounts.push(acc);
          break;
        case ACCOUNT_STATUS.ON_HOLD:
          if (isAdmin) {
            onHoldAccounts.push(acc);
          } else {
            // For non-admin users, merge on hold accounts into active
            activeAccounts.push(acc);
          }
          break;
        case ACCOUNT_STATUS.INACTIVE:
        default:
          // no status → treat as inactive
          inactiveAccounts.push(acc);
          break;
      }
    }

    return { activeAccounts, onHoldAccounts, inactiveAccounts };
  }, [accountsList, isAdmin]);

  const onSubmitAccount = event => {
    event.preventDefault();
    if (selected) {
      setSelectedAccountById(selected.id);
    }
  };

  const onChangeAndConfirm = account => {
    setSelected(account);
    setSelectedAccountById(account.id);
  };

  const hasActiveAccounts = activeAccounts.length > 0;
  const hasOnHoldAccounts = onHoldAccounts.length > 0;
  const hasInactiveAccounts = inactiveAccounts.length > 0;

  return (
    <form className="accountSelectorForm" data-seleniumid="accountSelectorForm" onSubmit={onSubmitAccount}>
      <h4>Please choose the account you wish to manage</h4>

      <AccountSelector onChange={setSelected} onChangeAndConfirm={onChangeAndConfirm} selected={selected} />

      {(hasActiveAccounts && activeAccounts.length > 1) || (isAdmin && hasOnHoldAccounts) || hasInactiveAccounts ? (
        <button className="btn btn-secondary" data-seleniumid="accountSelectorForm-btnContinue" type="submit">
          Continue
        </button>
      ) : null}
    </form>
  );
};

export default AccountSelectorForm;
